<template>
    <!--    the parent route has div row and col-12 specified-->
    <np-skeleton v-if="!objectIsNotEmpty(quote) && !objectIsNotEmpty(parameters)" :type="'forms'"></np-skeleton>
    <div v-else>
        <np-application-breadcrumb :crumbs="businessTabsToRender" :mode="'pagecrumb'"></np-application-breadcrumb>
        <router-view></router-view>
    </div>

</template>

<script>

    import {NPSkeleton,} from "../../../../js/netpify/components";
    import utilMixin from "../../../utils/mixins";
    import applicationMixin from "../../../utils/application-mixin";
    import NPAppBreadcrumb from "../../../components/np-application-breadcrumb.vue";
    import * as types from "../../../stores/constants";

    import {Quote} from "../../../entities";
    import {mapActions} from "pinia";
    import paths from "../../../router/paths";
    import useApplicationStore from "../../../stores/application_module";
    const STANDALONE_SERVICE = "STANDALONE_SERVICE";
    const ACCESSORY = "ACCESSORY";
    const GLOBAL_FEATURE = "GLOBAL_FEATURE";
    export default {
        name: "businessInfoParent",
        mixins: [utilMixin, applicationMixin],
        components: {
            'np-application-breadcrumb': NPAppBreadcrumb,
            'np-skeleton': NPSkeleton,
        },
        data() {
            return {
                business_sub_tabs: [
                    {
                        // class: "btn btn-default",
                        display: true,
                        // icon: "flaticon-cogwheels12",
                        is_active: true,
                        is_open: false,
                        entity_type: 1,
                        component_name: 'BusinessInfo',
                        short_label: "business",
                        label: "tab_business_information",
                        // lang_key: "tab_business_information",
                        tab_id: "tab_business_information",
                        url: "",
                      path: '',
                    },
                    {
                        // class: "btn btn-default",
                        display: true,
                        // icon: "flaticon-cogwheels12",
                        is_active: true,
                        is_open: false,
                        short_label: "equipment",
                        component_name: 'Equipments',
                        label: "equipment",
                        tab_id: "tab_equipment",
                        url: "products/",
                        path: "products/",
                    }, {
                        // class: "btn btn-default",
                        display: true,
                        // icon: "flaticon-cogwheels12",
                        is_active: true,
                        is_open: false,
                        short_label: "pricing",
                        component_name: 'Pricing',
                        label: "pricing",
                        tab_id: "tab_pricing",
                        url: "pricing/",
                        path: "pricing/",
                    },
                ],
                routes: [],
            }
        },
        mounted: function () {
            // Init currentRouteId from URL
            // this.refreshCurrentRouteId(this.$router.currentRoute)
            //
            // // Handle manual page change
            // this.$router.afterEach((to, from) => {
            //   //console.log(to)
            //     this.refreshCurrentRouteId(to)
            // })
        },
        computed: {
            parameters: function () {
                return this.$parent.parameters;
            },
            businessTabsToRender: function () {
                let tabs = this.jsonCopy(this.business_sub_tabs);
                tabs.forEach(obj => {

                    //block user from using any application/add routes apart from business/ which is the default
                    if (this.quote_root_path.includes('application/add') && obj.url !== ''){
                        obj.is_active = false;
                    }
                    obj.url = this.quote_root_path + 'business/' + obj.url;
                })

                return tabs;
            },
            inViewMode: function () {
                return this.quote_root_path.includes('quote/view');
            },
            isFirstPage: function () {
                return this.currentRouteId === 0
            },
            isIndexPage: function () {
                let resp = !( this.$route.path.includes('pricing') || this.$route.path.includes('products') )
                ////console.log(resp)
                return resp
            },
            isLastPage: function (){
                return this.currentRouteId === this.businessTabsToRender.length - 1
            },
            currentRouteId:  function (){
              let currentPath = this.$route;
              let route_id = this.businessTabsToRender.findIndex(route => { return route.url === currentPath.path});
              return route_id !== -1 ? route_id : 0;
            }
        },
        methods: {
            ...mapActions(useApplicationStore, [types.COMMIT_APPLICATION, types.COMMIT_QUOTE, types.FETCH_APPLICATION_DATA]),
            ...mapActions(useApplicationStore, [types.SET_MERCHANT_DATA, types.SET_QUOTE_DATA, types.SET_QUOTE_LOCK]),
            // refreshCurrentRouteId: function (currentPath) {
            //     let route_id = this.businessTabsToRender.findIndex(route => route.url === currentPath.path);
            //     this.currentRouteId = route_id !== -1 ? route_id : 0;
            // },
            backPage: function () {
                let prev_route = {};
                if (this.currentRouteId !== 0) {
                    prev_route = this.businessTabsToRender[this.currentRouteId - 1];

                    this.$router.push({path: prev_route.url});
                }
            },
            nextPage: function () {

                //update pricing then confirm the quote.
                // //console.log(this.application_root_path);
                // if (this.$route.path.includes('pricing')) {
                //     if(!this.isConvertedQuote) {
                //         this.confirmQuote();
                //     } else {
                //         this.$router.push({path: `${this.application_root_path}business_details`});
                //     }
                // } else {
                //     this.$router.push({path: `${this.application_root_path}products`});
                // }


                let next_route = {};
                if (this.currentRouteId < this.businessTabsToRender.length - 1) { // continue butto
                    next_route = this.businessTabsToRender[this.currentRouteId + 1];
                    this.$router.push({path: next_route.url})
                } else {
                    // confirm and submit
                    this.$router.push({path: `${this.application_root_path}business_details`});
                }
            },
            // getSelectedEquipmentOffer: function (offer){
            //     let selected_offer = {bundles: [], equipment_offering_external_id: offer.equipment_offering_external_id};
            //     let offerData = this.jsonCopy(offer)
            //     offerData.bundles = [];
            //     //merge equipment_list and bundle_packages into the bundles[]
            //     offerData.bundles.push(offer.equipment_list)
            //     offer.bundle_packages.forEach(obj => offerData.bundles.push(obj));
            //
            //     offerData.bundles.forEach((bundle, bundle_index) => {
            //         if (bundle.individual_item_only === '0' && bundle.selected === '0') {
            //
            //         } else if (bundle.individual_item_only === '0' && bundle.selected === '1') {
            //             //selected  bundle_packages
            //             selected_offer.bundles.push({
            //                 equipment_bundle_external_id: bundle.equipment_bundle_external_id,
            //                 bundle_name: bundle.bundle_name,
            //                 bundle_items: bundle.bundle_items,
            //                 selected: bundle.selected,
            //             })
            //         } else if(bundle.individual_item_only === '1') {
            //             //equipment_list
            //             if (bundle.bundle_items.length > 0) {
            //
            //                 let selected_bundle_items = [];
            //                 bundle.bundle_items.forEach((bundle_item, bundle_item_index) => {
            //                     if (!!bundle_item.selected || bundle_item.is_mandatory === '1') {
            //                         selected_bundle_items.push(bundle_item)
            //                     }
            //                 })
            //
            //                 if (selected_bundle_items.length > 0) {
            //                     selected_offer.bundles.push({
            //                         equipment_bundle_external_id: bundle.equipment_bundle_external_id,
            //                         bundle_name: bundle.bundle_name,
            //                         bundle_items: selected_bundle_items,
            //                         selected: '1',
            //                     })
            //                 }
            //             }
            //         }
            //     })
            //
            //     return selected_offer;
            //
            // },
//             validateQuoteForm: function () {
//                 //open all accordions before validating. Accordions don't validate nicely when closed.
//                 $('[id^=heading_]').removeClass('collapsed')
//                 $('[id^=collapse_]').addClass('show');
//                 let form_is_valid = this.validateForm('#form');
//                 let form = this.getFormData($('#form')), section = form.section;
//                 if (section === 'BUSINESS_INFO') {
//                     let turnover_fields = ['annual_turnover', 'monthly_card_turnover', 'avg_tran_value'];
//                     let turnover_errors = [];
//                     turnover_fields.forEach(obj => {
//                         if (this.quote.hasOwnProperty(obj) && !!this.quote[obj]) {
//                             if (this.countDecimals(this.quote[obj]) > 0) { //don't let any decimals.
//                                 turnover_errors.push(obj)
//                             }
//                         }
//                     })
//
//                     if (turnover_errors.length > 0) {
//                         this.notifyError(this.lang('validation_error'), this.lang('validation_integer'))
//                         // this.notifyError(this.lang('validation_error'), this.lang('validation_turnover_fields_two_decimals'))
//                         return false;
//                     }
//                 }
//
//                 if (this.$route.path.includes('products')){
//                     //TODO clean up.
//                     //if no offering is selected throw error
//                     //if offering is selected but no bundle item, throw error.
//                     let is_valid_equipment = false, is_valid_online = false;
//
//                     //validate Equipment offerings
//                     if (this.objectIsNotEmpty(this.equipment_offer)) {
//                         is_valid_equipment = this.checkEquipmentOfferIsSelected(this.equipment_offer)
//                     }
//
//                     //validate online offerings
//                     if (this.objectIsNotEmpty(this.online_offer)) {
//                         is_valid_online = this.checkEquipmentOfferIsSelected(this.online_offer, true);
//                     }
//
// //if card acceptance is both check both are selected.
// //                     if  is online and is_valid_online is false, throw error
// //                     else if its equipment  and is_valid_equipment  is false throw error
// //                     else if is both and either is_valid_online or is_valid_equipment is false
//                     if ((this.quote.payment_method === '2' || this.quote.payment_method === '3') && !is_valid_online) {
//                         this.notifyError(this.lang('validation_error'), this.lang('please_select_atleast_equipment_in_online_offering'));
//                         return false;
//                     }
//                     if ((this.quote.payment_method === '1' || this.quote.payment_method === '3') && !is_valid_equipment) {
//                         this.notifyError(this.lang('validation_error'), this.lang('please_select_only_one_equipment_in_equipment_offering'));
//
//                         // this.notifyError(this.lang('validation_error'), this.lang('please_select_atleast_equipment_in_equipment_offering'));
//                         return false;
//                     }
//
//                     //if no errors set the data
//                     if (is_valid_equipment) {
//                         this.$set(this.quote, 'equipment_offer', this.getSelectedEquipmentOffer(this.equipment_offer));
//                     }
//                     if (is_valid_online) {
//                         this.$set(this.quote, 'online_offer', this.getSelectedEquipmentOffer(this.online_offer));
//                     }
//
//
//                     // if (!is_valid_equipment && !is_valid_online){
//                     //     this.notifyError('Validation Error', 'Please select an Offering');
//                     //     return false;
//                     // }
//                 }
//
//                 //validate acquiring offering
//                 if (this.$route.path.includes('pricing')) {
//                     let is_valid_pricing = false;
//                     if (this.objectIsNotEmpty(this.quote.acquiring_offer)) {
//                         is_valid_pricing = this.checkPricingIsSelected(this.quote.acquiring_offer);
//                         if (!is_valid_pricing) {
//                             this.notifyError(this.lang('validation_error'), this.lang('please_select_pricing'))
//                             return false;
//                         }
//                         if(!!this.quote.pricing_has_error){
//                             this.notifyError(this.lang('validation_error'), this.lang('cannot_save_pricing'))
//                             return false;
//                         }
//                     }
//                 }
//
//                 return form_is_valid;
//             },
            recommitQuote: function (response){
                //don't recommit on these two pages else you will lose the UI layout for equipments page
                //only recommit on business info page because the offer may have changed
                if (!this.$route.path.includes('products') && !this.$route.path.includes('pricing')) {
                    response.data.quote = {...this.quote, ...response.data.quote}
                    this[types.COMMIT_QUOTE](response.data)
                }

                //if we update the merchant data, we should update the data on the front end
                if (!!response.data.application_updated && response.data.hasOwnProperty('application')) {
                    let application = response.data.application;

                    let payload = {
                        application_reference: application.application_reference
                    }
                    this[types.FETCH_APPLICATION_DATA](payload)
                }
            },

            // updateQuote: function (path_to = null) {
            //     let vm = this;
            //     if (!this.isLockedQuote) {
            //         if (this.validateQuoteForm()) {
            //             const url = `/quote/ajaxupdatequote`;
            //             let form = this.getFormData($('#form'));
            //             this.quote.section = form.section;
            //
            //             //TODO don't update if quote wasn't changed.
            //             return this.getAxiosInstance().post(url, this.quote).then(response => {
            //                 if (response['data']['result'] === 'SUCCESS') {
            //
            //                     this.recommitQuote(response)
            //                     this.notifySuccess(this.lang('quote_updated_successfully'))
            //
            //                     //update pricing then confirm the quote.
            //                     if (this.$route.path.includes('pricing') && !this.isConvertedQuote) {
            //                         return this.confirmQuote(path_to);
            //                     } else {
            //                         ////console.log('full', path_to)
            //                         if(  !path_to || (!!path_to && !path_to.fullPath) ) this.nextPage();
            //                     }
            //                     return true;
            //                 }
            //                 else {
            //                     return false;
            //                 }
            //             })
            //         } else {
            //             return false;
            //         }
            //     }else{
            //         if(  !path_to || (!!path_to && !path_to.fullPath) ) this.nextPage();
            //         return true;
            //     }
            // },
            // confirmQuote: function (path_to=null) {
            //     let vm = this;
            //     if (!this.isConvertedQuote) {
            //         const url = `/quote/ajaxconvertquote`;
            //
            //         const payload = {
            //             'quote_external_id': this.quote.quote_external_id
            //         }
            //         return this.getAxiosInstance().post(url, payload).then(response => {
            //             if (response['data']['result'] === 'SUCCESS') {
            //                 const {application} = response.data;
            //                 if (!!application) {
            //                     this.notifySuccess(this.lang('quote_converted_successfully'))
            //                     // this[types.SET_QUOTE_LOCK](true) //this ensure that isConvertedQuote is true even if we don't recommit quote
            //
            //                     let application_reference = application.application_reference;
            //                     //the data that comes from quote convert doesn't have the outlet and other stuff so best to
            //                     //fetch the entire application
            //                     let application_payload = {
            //                         application_reference: application.application_reference,
            //                     }
            //
            //                     // this.$parent.fetchApplicationData(application_reference);
            //                     // this[types.FETCH_APPLICATION_DATA](application_payload)
            //
            //                     //reload the whole application
            //                     if(  !path_to || (!!path_to && !path_to.fullPath) ) this.$router.push({path: '/application/edit/'+ application_reference+'/business_details'})
            //                     //if(  !path_to || (!!path_to && !path_to.fullPath) ) location.href = '/application/edit/'+ application_reference+'/business_details';
            //
            //                     return true;
            //
            //                     //removed
            //                     // this[types.COMMIT_APPLICATION](response.data);
            //                     // this.nextPage()
            //                 }
            //             } else return false;
            //         });
            //     } else {
            //         if(  !path_to || (!!path_to && !path_to.fullPath) ) this.nextPage();
            //         return true;
            //     }
            // }
        },

    }
</script>

<style scoped>
</style>